export default __webpack_public_path__ + "static/media/img-service.68a74a60.png";